import { CloseIcon } from '@halo/ui-chat-react';
import { Box, Steps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import LogoIcon from './images/logo.svg?react';
import stepImg from './images/step.png';
import SuccessIcon from './images/sucess.svg?react';
import ProgressIcon from './images/progress.svg?react';
import DotIcon from './images/dot.svg?react';
import styles from './index.module.scss';

export const enum DeleteStepsEnum {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
}

export const enum statusEnum {
  default = 'default',
  error = 'error',
  success = 'success',
  progress = 'progress',
}
export interface Step {
  value: DeleteStepsEnum;
  status?: statusEnum;
}

const DeleteSteps = ({ step, filterValues }: { step: Step; filterValues: DeleteStepsEnum[] }) => {
  const { t } = useTranslation();
  const [items, setItems] = useState([
    {
      id: DeleteStepsEnum.ONE,
      titleKey: 'settings.deleteMyAccountSteps.deletingAccountFromServer',
      status: statusEnum.default,
      icon: <DotIcon />,
    },
    {
      id: DeleteStepsEnum.TWO,
      titleKey: 'settings.deleteMyAccountSteps.removingWalletBackups',
      status: statusEnum.default,
      icon: <DotIcon />,
    },
    {
      id: DeleteStepsEnum.THREE,
      titleKey: 'settings.deleteMyAccountSteps.erasingContactBackups',
      status: statusEnum.default,
      icon: <DotIcon />,
    },
    {
      id: DeleteStepsEnum.FOUR,
      titleKey: 'settings.deleteMyAccountSteps.removingAccountFromDevices',
      status: statusEnum.default,
      icon: <DotIcon />,
    },
    {
      id: DeleteStepsEnum.FIVE,
      titleKey: 'settings.deleteMyAccountSteps.clearingLocalData',
      status: statusEnum.default,
      icon: <DotIcon />,
    },
  ]);

  const stepIcons = useCallback((status: statusEnum) => {
    return {
      [statusEnum.default]: <DotIcon />,
      [statusEnum.error]: <CloseIcon />,
      [statusEnum.success]: <SuccessIcon />,
      [statusEnum.progress]: <ProgressIcon />,
    }[status];
  }, []);

  const current = useMemo(() => {
    return items.find((item) => item.id === step?.value);
  }, [step, items]);

  useEffect(() => {
    setItems((items) => {
      return items
        .filter((item) =>
          item.id === DeleteStepsEnum.TWO || item.id === DeleteStepsEnum.THREE
            ? filterValues.includes(item.id)
            : true
        )
        .map((item) => {
          let status = item.status;

          if (step?.value > item.id) {
            if (status === statusEnum.error) {
              status = statusEnum.error;
            } else {
              status = statusEnum.success;
            }
          } else {
            if (step?.value === item.id) {
              if (step.status === statusEnum.error) {
                status = statusEnum.error;
              } else {
                status = statusEnum.progress;
              }
            }
          }

          return {
            ...item,
            status,
            icon: stepIcons(status),
          };
        });
    });
  }, [stepIcons, step, filterValues]);

  return (
    <div className={styles.stepsWrapper}>
      <div className={styles.top}>
        <div className={styles.logo}>
          <LogoIcon />
          <div>HaloChat</div>
        </div>
        <div className={styles.text}>{t('settings.deleteMyAccount')}</div>
        <div className={styles.subText}>{t('settings.pleaseWaitPatiently')}</div>
        <img className={styles.img} src={stepImg} />
      </div>
      <Box flex="1" display="flex" alignItems="center">
        <Steps.Root orientation="vertical" height="400px" step={current?.id} count={items.length}>
          <Steps.List>
            {items.map((item) => {
              return (
                <Steps.Item key={item.id} index={item.id}>
                  <Steps.Indicator bg="transparent" border="0" p="0" h="6" w="6">
                    <Box color={item?.status === 'error' ? 'red.100' : 'green.100'}>
                      {item?.icon}
                    </Box>
                  </Steps.Indicator>
                  <Steps.Title
                    fontSize="lg"
                    color={
                      item?.status === 'error'
                        ? 'red.100'
                        : current?.id === item.id
                          ? 'green.100'
                          : 'fg'
                    }
                  >
                    {t(item.titleKey)}
                  </Steps.Title>
                  <Steps.Separator
                    ml="-2"
                    bg={item?.status === 'error' ? 'red.100' : 'green.100'}
                  />
                </Steps.Item>
              );
            })}
          </Steps.List>
        </Steps.Root>
      </Box>
    </div>
  );
};

export default DeleteSteps;
